import gql from 'graphql-tag';
import {
  COUPON_FRAGMENT,
  DISCOUNT_ACTIVITY_FRAGMENT,
  FULL_DISCOUNT_PRESENT_FRAGMENT,
  PURCHASE_PREMIUM_FRAGMENT,
  USER_COUPON_FRAGMENT,
} from '../fragments';

/**
 * 获取用户全部优惠卷
 */
export const fetchUserCouponsDocumenet = gql`
  query userCoupons($options: UserCouponListOptions) {
    userCoupons(options: $options) {
      items {
        ...UserCoupon
      }
      totalItems
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 获取用户优惠卷详情
 */
export const fetchUserCouponDocumenet = gql`
  query userCoupon($options: UserCouponListOptions, $userCouponId: ID!, $removeNewTag: Boolean) {
    userCoupon(options: $options, userCouponId: $userCouponId, removeNewTag: $removeNewTag) {
      ...UserCoupon
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 获取优惠卷详情
 */
export const fetchGetCouponOneDocumenet = gql`
  query getCouponOne($options: CouponListOptions, $couponId: ID!) {
    getCouponOne(options: $options, couponId: $couponId) {
      ...Coupon
    }
  }
  ${COUPON_FRAGMENT}
`;

/**
 * 领取优惠卷
 */
export const fetchClaimCouponDocumenet = gql`
  mutation claimCoupon($couponId: ID!) {
    claimCoupon(couponId: $couponId) {
      ...UserCoupon
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 获取 可用/不可用 优惠券列表
 */
export const fetchGetActiveCouponsDocumenet = gql`
  query getActiveCoupons($orderId: ID) {
    getActiveCoupons(orderId: $orderId) {
      availableCoupons {
        ...UserCoupon
      }
      couponsAreNotAvailable {
        ...UserCoupon
      }
      lackOfExchangeGoodsCoupons {
        ...UserCoupon
      }
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 使用优惠券优惠
 */
export const fetchApplyCouponDocument = gql`
  mutation applyCoupon($userCouponId: ID!, $orderId: ID) {
    applyCoupon(userCouponId: $userCouponId, orderId: $orderId) {
      id
    }
  }
`;

/**
 * 取消使用优惠券优惠
 */
export const fetchCancelCouponDocument = gql`
  mutation cancelCoupon($orderId: ID) {
    cancelCoupon(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 获取当前活跃订单正在使用的优惠信息
 */
export const fetchGetOrderDiscountsDocument = gql`
  query getOrderDiscounts($orderId: ID) {
    getOrderDiscounts(orderId: $orderId) {
      couponDiscounts {
        discount {
          adjustmentSource
          type
          description
          amount
        }
        activities {
          ...UserCoupon
        }
      }
      memberDiscounts {
        discount {
          adjustmentSource
          type
          description
          amount
        }
      }
      purchasePremiumDiscounts {
        discount {
          adjustmentSource
          type
          description
          amount
        }
        activities {
          ...PurchasePremium
        }
      }
      discountActivities {
        discount {
          adjustmentSource
          type
          description
          amount
        }
        activities {
          ...DiscountActivity
        }
      }
      fullDiscountPresent {
        discount {
          adjustmentSource
          type
          description
          amount
        }
        activities {
          ...FullDiscountPresent
        }
      }
    }
  }
  ${USER_COUPON_FRAGMENT}
  ${PURCHASE_PREMIUM_FRAGMENT}
  ${FULL_DISCOUNT_PRESENT_FRAGMENT}
  ${DISCOUNT_ACTIVITY_FRAGMENT}
`;

/**
 * 获取优惠券的持有信息
 */
export const fetchGetCouponHoldDocument = gql`
  query getCouponHold($couponId: ID!) {
    getCouponHold(couponId: $couponId) {
      coupon {
        ...Coupon
      }
      usableCoupons {
        ...UserCoupon
      }
      expiredCoupons {
        ...UserCoupon
      }
      usedCoupons {
        ...UserCoupon
      }
      notStartedCoupons {
        ...UserCoupon
      }
      residualNumber
    }
  }
  ${COUPON_FRAGMENT}
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 获取优惠券礼包详情
 */
export const fetchGetCouponBundleDocument = gql`
  query couponBundle($id: ID!) {
    couponBundle(id: $id) {
      id
      createdAt
      updatedAt
      name
      remarks
      totalQuantity
      receivedQuantity
      state
      invalidCondition
      introduce
      smallProgramQRCodeLink
      couponBundleItems {
        id
        couponBundleId
        createdAt
        updatedAt
        quantity
        coupon {
          ...Coupon
        }
      }
      availableCoupon {
        quantity
        coupon {
          ...Coupon
        }
      }
    }
  }

  fragment Coupon on Coupon {
    __typename
    id
    createdAt
    state
    enable
    updatedAt
    name
    remarks
    type
    preferentialContent {
      preferentialType
      minimum
      discount
      maximumOffer
      includingDiscountProducts
    }
    validityPeriod {
      type
      startTime
      endTime
      numberOfDays
    }
    totalQuantity
    applicableProduct {
      applicableType
      productIds
    }
    whetherRestrictUsers
    memberPlanIds
    introduce
    promotion {
      id
    }
    memberPlanIds
    activityContent
    activityTime
  }
`;
/**
 * 领取优惠卷礼包
 */
export const fetchReceiveCouponBundleDocumenet = gql`
  mutation receiveCouponBundle($id: ID!) {
    receiveCouponBundle(id: $id) {
      ...UserCoupon
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 获取已经领取过的优惠券数据
 */
export const fetchGetReceivedCouponBundlesDocument = gql`
  query getReceivedCouponBundles($couponBundleId: ID!) {
    getReceivedCouponBundles(couponBundleId: $couponBundleId) {
      coupon {
        ...Coupon
      }
      quantity
    }
  }
  ${COUPON_FRAGMENT}
`;

/**
 * 获取活跃的新客福利
 */
export const fetchGetActiveFirstCustomerBenefitDocument = gql`
  query getActiveFirstCustomerBenefit {
    getActiveFirstCustomerBenefit {
      id
      name
      state
      firstCustomerBenefitItems {
        id
        quantity
        coupon {
          ...Coupon
        }
      }
      availableCoupon {
        quantity
        coupon {
          ...Coupon
        }
      }
    }
  }
  ${COUPON_FRAGMENT}
`;

/**
 * 领取新客福利
 */
export const fetchReceiveFirstCustomerBenefitDocumenet = gql`
  mutation receiveFirstCustomerBenefit($id: ID!) {
    receiveFirstCustomerBenefit(id: $id) {
      ...UserCoupon
    }
  }
  ${USER_COUPON_FRAGMENT}
`;

/**
 * 订单应用优惠券
 */
export const fetchOrderApplyCouponDocument = gql`
  mutation orderApplyCoupon($orderId: ID!) {
    orderApplyCoupon(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 获取优惠券(全部)
 */
export const fetchCouponsDocumenet = gql`
  query coupons($couponIds: [ID!]!) {
    coupons(couponIds: $couponIds) {
      ...Coupon
    }
  }
  ${COUPON_FRAGMENT}
`;
